<template>
	<!-- Width/offset match the Svea iframe card below so the tabs read as part of
	it; the negative margin cancels the gap base puts between checkout sections. -->
	<div
		class="relative top-1 mx-auto -mb-6 max-w-[616px] rounded-xs border-t border-x border-slate-200 bg-white lg:-mb-8"
	>
		<div class="flex items-center mx-4">
			<div
				v-for="option in customerTypes"
				:key="option.value"
				class="inline-flex items-center bg-white w-full"
			>
				<label
					class="relative flex p-4 w-full items-center justify-center cursor-pointer font-semibold after:content-[''] after:absolute after:bottom-0 after:w-full"
					:for="`customer-type-${option.value}`"
					:class="
						modelValue === option.value
							? 'text-blue-darker after:h-1 after:bg-blue-darker'
							: 'text-blue after:h-[2px] after:bg-blue'
					"
				>
					<input
						:id="`customer-type-${option.value}`"
						type="radio"
						name="customer-type"
						class="peer hidden"
						:value="option.value"
						:checked="modelValue === option.value"
						:disabled="disabled"
						@change="emit('update:modelValue', option.value)"
					/>
					{{ option.label }}
				</label>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
// Design-only override of the base component: tabs that visually merge into the
// Svea iframe below. Same contract as layers/base — no logic lives here, the
// order lifecycle stays in base Checkout.vue.
const { modelValue } = defineProps<{
	modelValue: string;
	disabled?: boolean;
}>();
const emit = defineEmits<{ "update:modelValue": [value: string] }>();

const customerTypes = [
	{ value: "person", label: "Person" },
	{ value: "organization", label: "Organization" }
];
</script>
